
(function(template){
define('vue!modeSelector/components/LoginComponent',['Vue','vuex','vue!basicComponents/inputIconField','helpers','vue!app/views/vue/components/cartComponent/addGuestComponent/loginComponent'],function(Vue,vuex,inputIconField,helpers,loginComponent){
    return {
        name: 'Login-Segment',
        template: template,
        components: {
            'input-icon-field': inputIconField,
            'login-component' : loginComponent
        },
        props: ['userLoggedIn','fromApp'],
        data: function(){
            return {
                showLoginComponent: true,
                email: '',
                password: '',
                showPassword: false
            }
        },
        methods: {
            handleSubmit : function(){
                this.$emit('update:userLoggedIn',true); 
            }
        }
    }
})
})('<div> <p v-if="!fromApp">{{localization.spaBooking.packageBooking.modeSelector.login.header}}</p> <p v-else>{{localization.spaBooking.packageBooking.login.ui.provideEmailLabel}}</p> <login-component :modeSelect="true" @loginSuccess="handleSubmit" ></login-component> </div>');
